import { AxiosProgressEvent } from 'axios';
import { httpService } from 'shared/api';
import { IAsset } from './types';

const assetsEndpoint = '/assets';
export const assetApi = {
  create: async (
    data: FormData,
    onUploadProgress?: (e: AxiosProgressEvent) => void
  ) => {
    const response = await httpService.post<IAsset>(
      assetsEndpoint + '/',
      data,
      {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress,
        timeout: 1800000
      }
    );

    return response.data;
  }
};
